import React from 'react';
import { Button } from 'reactstrap';
// import { DeleteUnitConversion } from './DeleteUnitConversion';
import { FormUnitConversion } from './FormUnitConversion';
import { Dialog } from 'primereact/dialog';


export const ModalUnitConversion = (props) => {

    const { modal, closeDialog, loading, method, units, id_unit_from, id_unit_to, conversion_factor, handleInputChange, saveCreate, saveUpdate, saveDelete } = props;
    
    const footer = (
        <div className='mt-2' style={{ display: "flex", justifyContent: "flex-end"}}>
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>

            <Button
                color="primary"
                size="sm"
                disabled={loading}
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "progress-bar-animated progress-bar-striped" : ""}
            >
                {
                    loading
                        ? (
                            <>
                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                {
                                    method === "create"
                                        ? "Guardando..."
                                        : "Actualizando..."
                                }
                            </>
                        )
                        : (
                            method === "create"
                                ? "Guardar"
                                : "Actualizar"
                        )
                }
            </Button>
            
        </div>
    );

    return (
        <Dialog 
            header= {
                        method === "create" ?
                            "Creación de unidades"
                            : (method === "update") ?
                                "Actualización de unidad"
                                : "Eliminar unidad"
                    } 
            visible={modal} 
            onHide={closeDialog} 
            closable 
            modal 
            blockScroll 
            className='medium-dialog'
            footer={footer}
        >
            {
                method === "create" ?
                    <FormUnitConversion button="Crear nueva unidad" {...{loading, units, id_unit_from, id_unit_to, conversion_factor, handleInputChange, methodAction: saveCreate }} />
                    : (method === "update") ?
                        <FormUnitConversion button="Actualizar unidad" {...{loading, units, id_unit_from, id_unit_to, conversion_factor, handleInputChange, methodAction: saveUpdate }} />
                        : null
            }
        </Dialog>
    )
}
